module.exports = __webpack_public_path__ + "img/pagina menu correios idcorreios.ff9a8b4f.png";